import React, {PropsWithChildren} from 'react';
import {Platform, TextStyle, View} from 'react-native';
import {useStyles} from '../../hooks/styles';
// StackHeaderTitleProps removed in React Navigation v7
interface StackHeaderTitleProps {
  children?: React.ReactNode;
  allowFontScaling?: boolean;
  tintColor?: string;
  style?: any;
}
import {Text} from '../text';

interface Props extends StackHeaderTitleProps {
  testID?: string;
  align: 'center' | 'left';
  title?: string | string[];
  numberOfLines?: number;
}

const RootMobileTitle: React.FC<PropsWithChildren<Props>> = (props: Props) => {
  const styles = useStyles(({theme}) => ({
    wrapper: {
      width: '100%',
    },
    text: {
      ...theme.fonts.h6,
      textAlign: props.align,
      flexWrap: 'wrap',
    },
  }));

  const titleBlock = Array.isArray(props.title) ? (
    props.title.map((text, idx) => (
      <TitleBlock
        testID={`title-block-${idx}-${props.testID}-id`}
        key={idx}
        style={styles.text}
        numberOfLines={props.numberOfLines}>
        {text}
      </TitleBlock>
    ))
  ) : (
    <TitleBlock testID={`title-block-1-${props.testID}-id`} style={styles.text} numberOfLines={props.numberOfLines}>
      {props.title ?? props.children}
    </TitleBlock>
  );

  return (
    <View testID={props.testID} style={styles.wrapper}>
      {titleBlock}
    </View>
  );
};

const TitleBlock: React.FC<PropsWithChildren<{style: TextStyle; numberOfLines?: number; testID: string}>> = (props) => {
  return (
    <Text
      style={props.style}
      numberOfLines={props.numberOfLines ?? 2}
      ellipsizeMode='clip'
      adjustsFontSizeToFit={Platform.OS === 'web'}
      minimumFontScale={Platform.OS === 'web' ? 0.5 : 1}>
      {props.children}
    </Text>
  );
};

export default RootMobileTitle;
